import React, { useEffect } from "react";

import { useHistory } from "react-router-dom";
import { ProtectedRoute } from "../../../Auth/ProtectedRoute/ProtectedRoute ";
import { Box, Typography, Button } from "@mui/material";
import FloatFooter from "../../../Shared/FloatFooter/FloatFooter";
import inspectionUploadService from "../../../Inspection/services/inspection-upload.service";
import { SystemFlagsEnum } from "../../../../models/session/system-flags.enum";
import inspectionConcludedImage from "../../../../assets/images/inspection/inspection-concluded.png";

const SummarySuccess = () => {
  const history = useHistory();

  const goToNewInspection = () => {
    history.push('../new-inspection/profile');
  }

  const goToInspectionPanel = () => {
    history.push('../first-step');
  }

  useEffect(() => {
    const isConnect = window.navigator.onLine;
    const isUploadingPhotos = JSON
      .parse(localStorage.getItem(SystemFlagsEnum.IS_UPLOADING_PHOTO) || '0');

    if (!isConnect) return;

    if (!isUploadingPhotos && isConnect) {
      inspectionUploadService.getAllAwaitingPhotos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ProtectedRoute>
      <div className="header-background" />
      <Box className="summary-container">
        <Box
          marginTop={'25px'}>
          <Typography
            fontWeight={600}
            fontFamily='Poppins'
            fontSize={'16px'}
          >Vistoria concluída!</Typography>
        </Box>
        <Box
          marginTop={'22px'}>
          <Typography
            fontWeight={400}
            fontFamily='Poppins'
            fontSize={'14px'}
          >
            Sua vistoria foi concluída. Faça outra<br />vistoria ou vá para o Painel de Vistorias.
          </Typography>
        </Box>
        <Box
          marginTop={'25px'}>
          <img
            src={inspectionConcludedImage}
            alt="inspection-concluded"
            className="ilustration"
            data-testid="inspection-concluded-image"
          />
        </Box>
      </Box>
      <FloatFooter>
        <Button
          fullWidth
          variant="outlined"
          className="primary-button"
          onClick={goToNewInspection}
        >Fazer outra vistoria</Button>
        <Button
          fullWidth
          variant="outlined"
          className="secondary-button"
          onClick={goToInspectionPanel}
        >Ir para Painel de Vistorias</Button>
      </FloatFooter>
    </ProtectedRoute>
  );
}

export default SummarySuccess;
